import React from 'react'
import { Provider } from 'react-redux'
import { Store } from 'redux'
import { BrowserRouter } from 'react-router-dom'
import AppRouter from './AppRouter'
import { PUBLIC_URL } from '../config'
import { ToastContextProvider } from './toast/toastContext'

interface AppProps {
  store: Store
}

const App = ({ store }: AppProps) => {
  return (
    <Provider store={store}>
      <BrowserRouter basename={PUBLIC_URL}>
        <ToastContextProvider>
          <AppRouter />
        </ToastContextProvider>
      </BrowserRouter>
    </Provider>
  )
}

export default App
